<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-form @submit.prevent="handleSubmit">
      <v-card :disabled="loading">
        <v-card-title class="d-flex align-center justify-space-between">
          <span>{{ title }}</span>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <SelectRequestedDocumentTypeBySubtype
            v-model="form.category_id"
            :lead-type-id="leadTypeId"
            :subtype-id="subtypeId"
            :placeholder="__('Nenhuma categoria disponível')"
            :excluded-category-ids="excludedCategoryIds"
            :error-messages="errors.category_id"
            :is-create-mode="isCreateMode"
            :disabled="isEdit"
          />

          <v-text-field
            v-model="form.request_date"
            :label="__('Data da solicitação')"
            type="date"
            :error-messages="errors.request_date"
            autofocus
            :max="formatDateForInput(new Date())"
          />

          <v-text-field
            v-if="isEdit"
            v-model="form.receipt_date"
            :label="__('Data de recebimento')"
            type="date"
            :error-messages="errors.receipt_date"
            :min="form.request_date"
            :max="formatDateForInput(new Date())"
          />

          <v-alert
            v-for="(message, index) in messages"
            :key="index"
            :type="message.type"
            text
            border="left"
          >
            <b>{{ message.title }}</b
            >: {{ message.description }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="close()" text>
            {{ __("Cancelar") }}
          </v-btn>
          <v-btn
            type="submit"
            color="primary"
            :loading="loading"
            :disabled="!form.category_id || !form.request_date"
          >
            {{ __("Salvar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";
import SelectRequestedDocumentTypeBySubtype from "@/components/RequestedDocumentsTypes/SelectRequestedDocumentTypeBySubtype.vue";
import { formatDateForInput } from "@/tools/date";

export default {
  mixins: [i18n],

  components: {
    SelectRequestedDocumentTypeBySubtype,
  },

  props: {
    leadTypeId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    subtypeId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      dialog: false,
      form: this.emptyForm(),
      formatDateForInput,
      errors: {},
      loading: false,
      messages: [],
      excludedCategoryIds: [],
      isEdit: false,
      isCreateMode: true,
    };
  },

  computed: {
    title() {
      return this.isEdit
        ? this.__("Alterar documento")
        : this.__("Adicionar documento");
    },
  },

  methods: {
    emptyForm() {
      return {
        id: null,
        category_id: null,
        request_date: formatDateForInput(new Date()),
        receipt_date: null,
      };
    },

    open(initialData = null, excludedCategoryIds = []) {
      this.form = this.emptyForm();
      this.excludedCategoryIds = excludedCategoryIds;
      this.errors = {};
      this.messages = [];

      if (initialData && initialData.id) {
        this.isEdit = true;
        this.isCreateMode = false;
        this.form.id = initialData.id;
        this.form.category_id = Number(initialData.category_id);
        this.form.request_date = initialData.request_date;
        this.form.receipt_date = initialData.receipt_date || null;
      } else {
        this.isEdit = false;
        this.isCreateMode = true;
        this.form.category_id = null;
        this.form.request_date = formatDateForInput(new Date());
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    handleSubmit() {
      this.errors = {};
      this.messages = [];
      this.$emit("submit", {
        id: this.form.id,
        category_id: this.form.category_id,
        request_date: this.form.request_date,
        receipt_date: this.isEdit ? this.form.receipt_date : undefined,
      });
    },

    setErrors(errors) {
      this.errors = errors;
    },

    setLoading(loading) {
      this.loading = loading;
    },

    setMessage(type, title, description) {
      this.messages = [{ type, title, description }];
    },

    clearMessages() {
      this.messages = [];
    },
  },
};
</script>
